import { Grid } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";

// Saving is the caller's business: one item is written as part of its whole collection.
const ItemFormDialog = ({
  title,
  FormFields,
  record,
  onSave,
  triggerButton,
  dialogSize = "md",
  transform,
  formProps,
}) => {
  const handleConfirm = data => onSave(transform ? transform(data) : data);

  return (
    <FormModal
      titleContent={title}
      triggerButton={triggerButton}
      dialogSize={dialogSize}
      defaultValues={record}
      saveTitle="Запази"
      onConfirm={handleConfirm}
      mode="onTouched"
    >
      <Grid
        container
        spacing={2}
      >
        <FormFields
          record={record}
          {...formProps}
        />
      </Grid>
    </FormModal>
  );
};

export default ItemFormDialog;
